import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);


const filtros = {
	state: {
		filtros : {
			candidaturas : {
				estado : [],
				text : '',
				type : '',
			},
			ofertas : {
				comun : {},
				date : 0,
				text : {
					titulo : '',
					provincia : '',
					titulaciones : '',
					empresa: '',
					sector: ''
				},
				omitirInscritos : false,
				paraProyectoTalento: false,
				paraIntermediacion: false,
				fechainicio : '',
			},
			misofertas : {
				estado : [],
				date : 0,
				titulo :'',
				type : [],
				omitirLeidos : false,
				caducanPronto : false,
				soloConCandidatos : false
			}
		}
	},
	getters: {
		getfiltroscandidaturas : state => state.filtros.candidaturas,   
		getfiltrosofertas : state => state.filtros.ofertas,   
		getfiltrosmisofertas : state => state.filtros.misofertas,   
	}, 
	actions: {
		requestSetFiltroCandidatura : function({commit}, data){
			commit('setfiltrosCandidaturas',data);
		},
		requestSetFiltroOfertas : function({commit}, data){
			commit('setfiltrosOfertas',data);
		},
		requestSetFiltroMisOfertas : function({commit}, data){
			commit('setfiltrosMisOfertas',data);
		}
	},
	mutations: {
		setfiltrosCandidaturas : function(state,data){
			state.filtros.candidaturas = data;
		},
		setfiltrosOfertas : function(state,data){
			state.filtros.ofertas = data;
		},
		setfiltrosMisOfertas : function(state,data){
			state.filtros.misofertas = data;
		}
	}
}

export default filtros;



// WEBPACK FOOTER //
// ./src/store/filtros.js